import React, { useState } from 'react';
import Autocomplete from 'react-autocomplete';
import { SearchInput } from '~/src/components/search-input';
import * as ST from './styled';

const NothingFound = () => (
    <ST.NothingFoundWrapper>
        <ST.NothingFoundTitle>Ничего не нашлось&nbsp;</ST.NothingFoundTitle>
        Возможно, вы неправильно ввели название канала
    </ST.NothingFoundWrapper>
);

export const ChannelSearch = ({ items, placeholder, onSearch, onClear, searchRef }) => {
    const [value, setValue] = useState('');

    const changeHandler = (e) => {
        setValue(e.target.value);
    };

    const selectHandler = (_, item) => {
        const title = item?.title;
        setValue(title ? title : '');
        onSearch(item);
    };

    const clearHandler = () => {
        setValue('');
        if (typeof onClear === 'function') {
 onClear();
}
    };

    const getItemValue = (item) => {
        return item.title;
    };

    const shouldItemRender = (item, value) => {
        if (!value) {
            return false;
        }
        return item.title.toString().toLowerCase().includes(value.toLowerCase());
    };

    const renderItem = (item, isHighlighted) => {
        return (
            <ST.SearchItem key={item.id} active={isHighlighted}>
                <ST.ChannelLogo src={item.logo} />
                {item.title}
            </ST.SearchItem>
        );
    };

    const renderMenu = (items) => {
        return (
            <ST.Dropdown>
                {items.length === 0 && value ? <NothingFound /> : items}
            </ST.Dropdown>
        );
    };

    const renderInput = (props) => {
        return (
            <SearchInput
                isSearchBtnInactive={true}
                onClear={clearHandler}
                {...props}
            />
        );
    };

    return (
        <ST.SeacrhInput
            data-test='search-field'
        >
            <Autocomplete
                wrapperStyle={ST.WRAPPER_STYLE}
                items={items}
                value={value}
                onChange={changeHandler}
                onSelect={selectHandler}
                getItemValue={getItemValue}
                shouldItemRender={shouldItemRender}
                renderInput={renderInput}
                renderItem={renderItem}
                renderMenu={renderMenu}
                inputProps={{ placeholder }}
                ref={searchRef}
            />
        </ST.SeacrhInput>
    );
};
